<template>  
  <div id="echart-pie" :style="{width: '100%', height: '100%'}"></div>   
</template>

<script>

// import echarts from  "echarts/dist/echarts";

export default {
 
methods:{

  initChart(name,rptData) {
   
      let getchart = this.$echarts.init(document.getElementById('echart-pie'));
      var  option = {
      /*title: {
        text: name,
        left: 'center',
        top: 'center'
      },*/
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name:'订单分布',
          type: 'pie',
          avoidLabelOverlap: false,
          itemStyle:{
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label:{
            show: false,
            position: 'center'
          },
          emphasis:{
            label:{
              show:true,
              fontSize: '30',
              fontWeight: 'bold'
            }
          },
          labelLine:{show:false},
          data: rptData/*[
            {
              value: 335,
              name: 'A'
            },
            {
              value: 234,
              name: 'B'
            },
            {
              value: 1548,
              name: 'C'
            }
          ]*/,
          radius: ['40%', '70%']
        }
      ]
    };
        

      getchart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        getchart.resize();
    });
  },

}

}
</script>


// WEBPACK FOOTER //
// src/components/pie.vue